module.exports = __webpack_public_path__ + "img/icon-kycImg.f786ddb0.svg";